// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ══════════════════════════════════════════════════════════
   EmployeeEnrollmentPage
   ══════════════════════════════════════════════════════════ */

.eep-root {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background: #f5f7fa;
}

/* ── Header ──────────────────────────────────────────────── */
.eep-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: #fff;
  border-bottom: 1px solid #eaecf0;
  flex-shrink: 0;
}

.eep-back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: none;
  background: #f0f2f5;
  color: #374151;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s;
}
.eep-back-btn:hover { background: #e5e7eb; }

.eep-header-text {
  flex: 1;
  min-width: 0;
}
.eep-header-text h1 {
  font-size: 16px;
  font-weight: 700;
  color: #1a2236;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.eep-header-text p {
  font-size: 12px;
  color: #6b7280;
  margin: 2px 0 0;
}

.eep-count-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 22px;
  height: 20px;
  padding: 0 7px;
  border-radius: 10px;
  background: #1e5fbc;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
}

.eep-refresh-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  background: #fff;
  color: #6b7280;
  cursor: pointer;
  transition: background 0.15s, color 0.15s;
  flex-shrink: 0;
}
.eep-refresh-btn:hover:not(:disabled) { background: #f0f2f5; color: #1e5fbc; }
.eep-refresh-btn:disabled { opacity: 0.4; cursor: not-allowed; }

/* ── Search + Filter bar ─────────────────────────────────── */
.eep-search-bar {
  display: flex;
  gap: 10px;
  padding: 14px 20px;
  background: #fff;
  border-bottom: 1px solid #eaecf0;
  flex-shrink: 0;
}

.eep-search-input-wrap {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
}
.eep-search-input-wrap > svg:first-child {
  position: absolute;
  left: 11px;
  color: #9ca3af;
  pointer-events: none;
}

.eep-search-input {
  width: 100%;
  height: 40px;
  padding: 0 36px 0 34px;
  border: 1px solid #d1d5db;
  border-radius: 10px;
  font-size: 14px;
  color: #1a2236;
  background: #f9fafb;
  outline: none;
  transition: border-color 0.15s;
  box-sizing: border-box;
}
.eep-search-input:focus { border-color: #1e5fbc; background: #fff; }

.eep-search-clear {
  position: absolute;
  right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: none;
  background: #e5e7eb;
  color: #6b7280;
  cursor: pointer;
  padding: 0;
}
.eep-search-clear:hover { background: #d1d5db; }

.eep-filter-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  height: 40px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #374151;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s, border-color 0.15s;
  position: relative;
}
.eep-filter-btn:hover { background: #f0f2f5; border-color: #9ca3af; }

.eep-filter-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: #1e5fbc;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
}

/* ── Employee list ───────────────────────────────────────── */
.eep-list-wrap {
  flex: 1;
  overflow-y: auto;
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.eep-list-center {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 60px 20px;
  color: #9ca3af;
  font-size: 14px;
  text-align: center;
}

.eep-empty-icon {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d1d5db;
}
.eep-empty-title { font-size: 15px; font-weight: 700; color: #374151; margin: 0; }
.eep-empty-sub   { font-size: 13px; color: #9ca3af; margin: 0; }

.eep-emp-card {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 14px 16px;
  border-radius: 12px;
  border: 1.5px solid #eaecf0;
  background: #fff;
  cursor: pointer;
  text-align: left;
  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;
  box-shadow: 0 1px 3px rgba(0,0,0,0.04);
}
.eep-emp-card:hover {
  border-color: #1e5fbc;
  box-shadow: 0 2px 8px rgba(30, 95, 188, 0.1);
  background: #fafcff;
}

.eep-emp-card-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #eff6ff;
  color: #1e5fbc;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.eep-emp-card-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.eep-emp-card-name {
  font-size: 14px;
  font-weight: 700;
  color: #1a2236;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.eep-emp-card-id {
  font-size: 12px;
  color: #6b7280;
  font-weight: 500;
}
.eep-emp-card-date {
  font-size: 11px;
  color: #9ca3af;
}

.eep-load-more {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px;
  font-size: 13px;
  color: #6b7280;
}
.eep-list-end {
  text-align: center;
  font-size: 12px;
  color: #d1d5db;
  padding: 12px 0 4px;
  margin: 0;
}

/* ── Filter sidebar ─────────────────────────────────────── */
.eep-filter-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(10, 14, 30, 0.5);
  z-index: 900;
  backdrop-filter: blur(2px);
}

.eep-filter-sidebar {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  width: min(360px, 100vw);
  background: #fff;
  z-index: 901;
  display: flex;
  flex-direction: column;
  box-shadow: -8px 0 32px rgba(0,0,0,0.18);
  animation: eep-slide-in 0.22s cubic-bezier(0.16, 1, 0.3, 1);
}
@keyframes eep-slide-in {
  from { transform: translateX(100%); }
  to   { transform: translateX(0); }
}

/* Sidebar header — gradient matching the palette */
.eep-filter-header {
  background: linear-gradient(135deg, #0d1b3e 0%, #1e4ba0 100%);
  padding: 20px;
  flex-shrink: 0;
}
.eep-filter-header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.eep-filter-title { font-size: 16px; font-weight: 800; color: #fff; }

.eep-filter-close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: rgba(255,255,255,0.15);
  color: #fff;
  cursor: pointer;
  transition: background 0.15s;
}
.eep-filter-close-btn:hover { background: rgba(255,255,255,0.28); }

.eep-filter-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 40px;
  color: #6b7280;
  font-size: 14px;
}

/* Body */
.eep-filter-body {
  flex: 1;
  overflow-y: auto;
  padding: 24px 20px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background: #f8fafc;
}

/* Individual field */
.eep-filter-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.eep-filter-field-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.6px;
  color: #64748b;
}

/* Custom select */
.eep-filter-select-wrap {
  position: relative;
}
.eep-filter-select {
  width: 100%;
  height: 44px;
  padding: 0 36px 0 14px;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  color: #1a2236;
  background: #fff;
  outline: none;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  box-sizing: border-box;
  transition: border-color 0.15s;
}
.eep-filter-select:focus { border-color: #1e5fbc; }
.eep-filter-select-arrow {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  font-size: 12px;
  pointer-events: none;
}

/* Footer */
.eep-filter-footer {
  display: flex;
  gap: 10px;
  padding: 16px 20px;
  border-top: 1px solid #eaecf0;
  flex-shrink: 0;
  background: #fff;
}
.eep-filter-clear-btn {
  flex: 1;
  height: 44px;
  border-radius: 10px;
  border: 1.5px solid #e2e8f0;
  background: #fff;
  color: #374151;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.12s;
}
.eep-filter-clear-btn:hover { background: #f0f4f8; }
.eep-filter-apply-btn {
  flex: 2;
  height: 44px;
  border-radius: 10px;
  border: none;
  background: linear-gradient(135deg, #0d1b3e, #1e5fbc);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s;
}
.eep-filter-apply-btn:hover { opacity: 0.9; }

/* ── Registration body ──────────────────────────────────── */
.eep-reg-body {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 28px 20px;
}

.eep-reg-card {
  width: 100%;
  max-width: 500px;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.07);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

/* ── Employee banner (register view) ────────────────────── */
.eep-emp-banner {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-radius: 10px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
}
.eep-emp-info { display: flex; flex-direction: column; gap: 2px; }
.eep-emp-name { font-size: 15px; font-weight: 700; color: #1a2236; }
.eep-emp-id   { font-size: 12px; color: #6b7280; }

/* ── Input step ─────────────────────────────────────────── */
.eep-step-input {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  align-items: stretch;
}
.eep-field-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
}
.eep-field-input {
  width: 100%;
  height: 44px;
  padding: 0 14px;
  border: 1.5px solid #d1d5db;
  border-radius: 10px;
  font-size: 14px;
  color: #1a2236;
  outline: none;
  box-sizing: border-box;
  transition: border-color 0.15s;
}
.eep-field-input:focus { border-color: #1e5fbc; }
.eep-step-error {
  padding: 10px 14px;
  border-radius: 8px;
  background: #fff1f2;
  border: 1px solid #fecdd3;
  color: #be123c;
  font-size: 13px;
}

/* ── Camera step ────────────────────────────────────────── */
.eep-step-camera {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
}

.eep-video-wrap {
  position: relative;
  width: 100%;
  aspect-ratio: 4 / 3;
  border-radius: 12px;
  overflow: hidden;
  background: #111827;
}

.eep-video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0;
  transition: opacity 0.3s;
}
.eep-video.ready { opacity: 1; }

.eep-video-loading {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #94a3b8;
  font-size: 14px;
}

.eep-camera-error {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: #94a3b8;
  padding: 20px;
  text-align: center;
  font-size: 14px;
}

.eep-face-guide {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}
.eep-face-guide::after {
  content: "";
  width: 52%;
  aspect-ratio: 3 / 4;
  border: 2.5px solid rgba(255,255,255,0.65);
  border-radius: 50%;
  box-shadow: 0 0 0 9999px rgba(0,0,0,0.32);
}

.eep-cam-flip-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  border: none;
  background: rgba(0,0,0,0.45);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s;
  z-index: 2;
}
.eep-cam-flip-btn:hover { background: rgba(0,0,0,0.65); }

.eep-retry-btn {
  padding: 8px 20px;
  border-radius: 8px;
  border: 1px solid #6b7280;
  background: transparent;
  color: #9ca3af;
  font-size: 13px;
  cursor: pointer;
}

.eep-capture-status {
  width: 100%;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  text-align: center;
}
.eep-capture-status.ok   { background: #f0fdf4; color: #15803d; border: 1px solid #bbf7d0; }
.eep-capture-status.fail { background: #fff1f2; color: #be123c; border: 1px solid #fecdd3; }

.eep-capture-hint {
  font-size: 12px;
  color: #9ca3af;
  text-align: center;
}

.eep-text-btn {
  background: none;
  border: none;
  color: #6b7280;
  font-size: 13px;
  cursor: pointer;
  padding: 4px 0;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.eep-text-btn:hover { color: #374151; }

/* ── Preview step ───────────────────────────────────────── */
.eep-step-preview {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
  align-items: center;
}
.eep-preview-label {
  font-size: 13px;
  font-weight: 700;
  color: #374151;
  margin: 0;
  align-self: flex-start;
}
.eep-preview-img-wrap {
  width: 100%;
  border-radius: 12px;
  overflow: hidden;
  border: 1.5px solid #eaecf0;
  background: #111827;
  aspect-ratio: 4 / 3;
}
.eep-preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.eep-preview-actions {
  display: flex;
  gap: 10px;
  width: 100%;
}
/* Fix: override width:100% so Register shares the row evenly with Retake */
.eep-preview-actions .eep-action-btn,
.eep-success-actions .eep-action-btn {
  width: auto;
  flex: 2;
}

/* ── Enrolling step ─────────────────────────────────────── */
.eep-step-enrolling {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 20px 0;
}
.eep-enrolling-spinner {
  width: 52px;
  height: 52px;
  border: 4px solid #e2e8f0;
  border-top-color: #1e5fbc;
  border-radius: 50%;
  animation: eep-spin 0.8s linear infinite;
}
.eep-enrolling-msg {
  font-size: 15px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

/* ── Success step ───────────────────────────────────────── */
.eep-step-success {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 10px 0;
  text-align: center;
}
.eep-success-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #f0fdf4;
  border: 2px solid #bbf7d0;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: eep-pop-in 0.3s cubic-bezier(0.16,1,0.3,1);
}
@keyframes eep-pop-in {
  from { transform: scale(0.7); opacity: 0; }
  to   { transform: scale(1);   opacity: 1; }
}
.eep-success-title {
  font-size: 20px;
  font-weight: 800;
  color: #1a2236;
  margin: 0;
}
.eep-success-sub {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
}
.eep-success-api-msg {
  font-size: 13px;
  font-weight: 600;
  color: #16a34a;
  margin: 0;
  padding: 8px 16px;
  background: #f0fdf4;
  border-radius: 8px;
  border: 1px solid #bbf7d0;
  width: 100%;
}
.eep-success-actions {
  display: flex;
  gap: 10px;
  width: 100%;
  margin-top: 4px;
}

/* ── Shared buttons ─────────────────────────────────────── */
.eep-action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 46px;
  border-radius: 10px;
  border: none;
  background: linear-gradient(135deg, #0d1b3e, #1e5fbc);
  color: #fff;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.15s, transform 0.1s;
  flex-shrink: 0;
}
.eep-action-btn:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); }
.eep-action-btn:disabled { opacity: 0.5; cursor: not-allowed; }

.eep-secondary-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 46px;
  border-radius: 10px;
  border: 1.5px solid #d1d5db;
  background: #fff;
  color: #374151;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.15s;
}
.eep-secondary-btn:hover { background: #f0f2f5; }

/* ── Already-enrolled modal ─────────────────────────────── */
.eep-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}
.eep-modal {
  background: #fff;
  border-radius: 16px;
  padding: 28px 24px 22px;
  max-width: 400px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2);
  animation: eep-pop-in 0.25s cubic-bezier(0.16,1,0.3,1);
}
.eep-modal-icon {
  font-size: 36px;
  line-height: 1;
}
.eep-modal-title {
  font-size: 18px;
  font-weight: 800;
  color: #1a2236;
  margin: 0;
}
.eep-modal-msg {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
  line-height: 1.6;
}
.eep-modal-actions {
  display: flex;
  gap: 10px;
  width: 100%;
  margin-top: 6px;
}

/* ── Spinners ────────────────────────────────────────────── */
.eep-spinner {
  width: 26px;
  height: 26px;
  border: 3px solid #e2e8f0;
  border-top-color: #1e5fbc;
  border-radius: 50%;
  animation: eep-spin 0.7s linear infinite;
  flex-shrink: 0;
}
.eep-spinner-sm {
  width: 15px;
  height: 15px;
  border: 2px solid rgba(255,255,255,0.35);
  border-top-color: #fff;
  border-radius: 50%;
  animation: eep-spin 0.7s linear infinite;
  flex-shrink: 0;
}
@keyframes eep-spin { to { transform: rotate(360deg); } }

/* ══════════════════════════════════════════════════════════
   Dark mode
   ══════════════════════════════════════════════════════════ */
.dark .eep-root                 { background: #121827; }
.dark .eep-header               { background: #1a2236; border-color: #2e3d52; }
.dark .eep-header-text h1       { color: #e2e8f0; }
.dark .eep-header-text p        { color: #94a3b8; }
.dark .eep-back-btn             { background: #263348; color: #cbd5e1; }
.dark .eep-back-btn:hover       { background: #2e3d52; }
.dark .eep-refresh-btn          { background: #1a2236; border-color: #2e3d52; color: #94a3b8; }
.dark .eep-refresh-btn:hover    { background: #263348; color: #7eb3ff; }

/* Search bar */
.dark .eep-search-bar           { background: #1a2236; border-color: #2e3d52; }
.dark .eep-search-input         { background: #0f1724; border-color: #2e3d52; color: #e2e8f0; }
.dark .eep-search-input:focus   { border-color: #7eb3ff; }
.dark .eep-search-clear         { background: #263348; color: #94a3b8; }
.dark .eep-filter-btn           { background: #1a2236; border-color: #2e3d52; color: #cbd5e1; }
.dark .eep-filter-btn:hover     { background: #263348; }

/* List */
.dark .eep-list-wrap            { /* transparent */ }
.dark .eep-emp-card             { background: #1a2236; border-color: #2e3d52; }
.dark .eep-emp-card:hover       { border-color: #7eb3ff; background: #1e2a42; }
.dark .eep-emp-card-avatar      { background: #1e3a6e; color: #7eb3ff; }
.dark .eep-emp-card-name        { color: #e2e8f0; }
.dark .eep-emp-card-id          { color: #64748b; }
.dark .eep-emp-card-date        { color: #4b5e76; }
.dark .eep-empty-title          { color: #94a3b8; }

/* Filter sidebar */
.dark .eep-filter-backdrop      { background: rgba(0,0,0,0.65); }
.dark .eep-filter-sidebar       { background: #1a2236; }
/* header is gradient — stays dark */
.dark .eep-filter-body          { background: #0f1724; }
.dark .eep-filter-field-label   { color: #64748b; }
.dark .eep-filter-select        { background: #1a2236; border-color: #2e3d52; color: #e2e8f0; }
.dark .eep-filter-select:focus  { border-color: #7eb3ff; }
.dark .eep-filter-select-arrow  { color: #4b5e76; }
.dark .eep-filter-footer        { border-color: #2e3d52; background: #1a2236; }
.dark .eep-filter-clear-btn     { background: #1a2236; border-color: #2e3d52; color: #cbd5e1; }
.dark .eep-filter-clear-btn:hover { background: #263348; }

/* Registration */
.dark .eep-reg-card             { background: #1a2236; box-shadow: 0 4px 24px rgba(0,0,0,0.3); }
.dark .eep-emp-banner           { background: #0f1f3d; border-color: #1e3a6e; }
.dark .eep-emp-name             { color: #e2e8f0; }
.dark .eep-emp-id               { color: #94a3b8; }
.dark .eep-field-label          { color: #94a3b8; }
.dark .eep-field-input          { background: #0f1724; border-color: #2e3d52; color: #e2e8f0; }
.dark .eep-field-input:focus    { border-color: #7eb3ff; }
.dark .eep-step-error           { background: #1f0a10; border-color: #9f1239; color: #fb7185; }
.dark .eep-capture-status.ok    { background: #052e16; color: #4ade80; border-color: #166534; }
.dark .eep-capture-status.fail  { background: #1f0a10; color: #fb7185; border-color: #9f1239; }
.dark .eep-capture-hint         { color: #64748b; }
.dark .eep-preview-label        { color: #94a3b8; }
.dark .eep-preview-img-wrap     { border-color: #2e3d52; }
.dark .eep-enrolling-msg        { color: #94a3b8; }
.dark .eep-enrolling-spinner    { border-color: #2e3d52; border-top-color: #7eb3ff; }
.dark .eep-spinner              { border-color: #2e3d52; border-top-color: #7eb3ff; }
.dark .eep-success-title        { color: #e2e8f0; }
.dark .eep-success-sub          { color: #94a3b8; }
.dark .eep-success-api-msg      { background: #052e16; border-color: #166534; color: #4ade80; }
.dark .eep-success-icon         { background: #052e16; border-color: #166534; }
.dark .eep-secondary-btn        { background: #1a2236; border-color: #2e3d52; color: #cbd5e1; }
.dark .eep-secondary-btn:hover  { background: #263348; }
.dark .eep-text-btn             { color: #64748b; }
.dark .eep-text-btn:hover       { color: #94a3b8; }
.dark .eep-modal                { background: #1a2236; }
.dark .eep-modal-title          { color: #e2e8f0; }
.dark .eep-modal-msg            { color: #94a3b8; }
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/EmployeeEnrollmentPage.css"],"names":[],"mappings":"AAAA;;+DAE+D;;AAE/D;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;AACA,sBAAsB,mBAAmB,EAAE;;AAE3C;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,yCAAyC;EACzC,cAAc;AAChB;AACA,wCAAwC,mBAAmB,EAAE,cAAc,EAAE;AAC7E,4BAA4B,YAAY,EAAE,mBAAmB,EAAE;;AAE/D,+DAA+D;AAC/D;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;AACxB;AACA,0BAA0B,qBAAqB,EAAE,gBAAgB,EAAE;;AAEnE;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,UAAU;AACZ;AACA,0BAA0B,mBAAmB,EAAE;;AAE/C;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gDAAgD;EAChD,kBAAkB;AACpB;AACA,wBAAwB,mBAAmB,EAAE,qBAAqB,EAAE;;AAEpE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA,+DAA+D;AAC/D;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;AACA,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE,SAAS,EAAE;AACjF,mBAAmB,eAAe,EAAE,cAAc,EAAE,SAAS,EAAE;;AAE/D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kEAAkE;EAClE,sCAAsC;AACxC;AACA;EACE,qBAAqB;EACrB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,aAAa;EACb,eAAe;EACf,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,SAAS;AACX;;AAEA,8DAA8D;AAC9D;EACE,eAAe;EACf,QAAQ;EACR,iCAAiC;EACjC,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,wCAAwC;EACxC,2DAA2D;AAC7D;AACA;EACE,OAAO,2BAA2B,EAAE;EACpC,OAAO,wBAAwB,EAAE;AACnC;;AAEA,mDAAmD;AACnD;EACE,6DAA6D;EAC7D,aAAa;EACb,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;AACA,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,WAAW,EAAE;;AAEpE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kCAAkC;EAClC,WAAW;EACX,eAAe;EACf,4BAA4B;AAC9B;AACA,8BAA8B,kCAAkC,EAAE;;AAElE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA,SAAS;AACT;EACE,OAAO;EACP,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,sBAAsB;EACtB,8BAA8B;AAChC;AACA,2BAA2B,qBAAqB,EAAE;AAClD;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,oBAAoB;AACtB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,8BAA8B,mBAAmB,EAAE;AACnD;EACE,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;AACA,8BAA8B,YAAY,EAAE;;AAE5C,8DAA8D;AAC9D;EACE,OAAO;EACP,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,8DAA8D;AAC9D;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;AAC3B;AACA,gBAAgB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACjE,gBAAgB,eAAe,EAAE,gBAAgB,EAAE,cAAc,EAAE;AACnE,gBAAgB,eAAe,EAAE,cAAc,EAAE;;AAEjD,8DAA8D;AAC9D;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;AACtB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,2BAA2B;EAC3B,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8BAA8B;AAChC;AACA,yBAAyB,qBAAqB,EAAE;AAChD;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA,8DAA8D;AAC9D;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,wBAAwB;AAC1B;AACA,mBAAmB,UAAU,EAAE;;AAE/B;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,UAAU;EACV,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,4BAA4B;EAC5B,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,4BAA4B;EAC5B,UAAU;AACZ;AACA,0BAA0B,4BAA4B,EAAE;;AAExD;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA,2BAA2B,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;AAC3F,2BAA2B,mBAAmB,EAAE,cAAc,EAAE,yBAAyB,EAAE;;AAE3F;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA,sBAAsB,cAAc,EAAE;;AAEtC,8DAA8D;AAC9D;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,WAAW;AACb;AACA,2EAA2E;AAC3E;;EAEE,WAAW;EACX,OAAO;AACT;;AAEA,8DAA8D;AAC9D;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,8DAA8D;AAC9D;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;AACvD;AACA;EACE,OAAO,qBAAqB,EAAE,UAAU,EAAE;EAC1C,OAAO,mBAAmB,IAAI,UAAU,EAAE;AAC5C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA,8DAA8D;AAC9D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yCAAyC;EACzC,cAAc;AAChB;AACA,uCAAuC,YAAY,EAAE,2BAA2B,EAAE;AAClF,2BAA2B,YAAY,EAAE,mBAAmB,EAAE;;AAE9D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,2BAA2B,mBAAmB,EAAE;;AAEhD,8DAA8D;AAC9D;EACE,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,uCAAuC;EACvC,sDAAsD;AACxD;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;AACA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA,+DAA+D;AAC/D;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,cAAc;AAChB;AACA,sBAAsB,KAAK,yBAAyB,EAAE,EAAE;;AAExD;;+DAE+D;AAC/D,kCAAkC,mBAAmB,EAAE;AACvD,kCAAkC,mBAAmB,EAAE,qBAAqB,EAAE;AAC9E,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,kCAAkC,mBAAmB,EAAE;AACvD,kCAAkC,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC9F,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;;AAEvE,eAAe;AACf,kCAAkC,mBAAmB,EAAE,qBAAqB,EAAE;AAC9E,kCAAkC,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC9F,kCAAkC,qBAAqB,EAAE;AACzD,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,kCAAkC,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC9F,kCAAkC,mBAAmB,EAAE;;AAEvD,SAAS;AACT,kCAAkC,gBAAgB,EAAE;AACpD,kCAAkC,mBAAmB,EAAE,qBAAqB,EAAE;AAC9E,kCAAkC,qBAAqB,EAAE,mBAAmB,EAAE;AAC9E,kCAAkC,mBAAmB,EAAE,cAAc,EAAE;AACvE,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,cAAc,EAAE;;AAElD,mBAAmB;AACnB,kCAAkC,4BAA4B,EAAE;AAChE,kCAAkC,mBAAmB,EAAE;AACvD,oCAAoC;AACpC,kCAAkC,mBAAmB,EAAE;AACvD,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC9F,kCAAkC,qBAAqB,EAAE;AACzD,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,qBAAqB,EAAE,mBAAmB,EAAE;AAC9E,kCAAkC,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC9F,oCAAoC,mBAAmB,EAAE;;AAEzD,iBAAiB;AACjB,kCAAkC,mBAAmB,EAAE,sCAAsC,EAAE;AAC/F,kCAAkC,mBAAmB,EAAE,qBAAqB,EAAE;AAC9E,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC9F,kCAAkC,qBAAqB,EAAE;AACzD,kCAAkC,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC9F,kCAAkC,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AAC9F,kCAAkC,mBAAmB,EAAE,cAAc,EAAE,qBAAqB,EAAE;AAC9F,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,qBAAqB,EAAE;AACzD,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,qBAAqB,EAAE,yBAAyB,EAAE;AACpF,kCAAkC,qBAAqB,EAAE,yBAAyB,EAAE;AACpF,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC9F,kCAAkC,mBAAmB,EAAE,qBAAqB,EAAE;AAC9E,kCAAkC,mBAAmB,EAAE,qBAAqB,EAAE,cAAc,EAAE;AAC9F,kCAAkC,mBAAmB,EAAE;AACvD,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,mBAAmB,EAAE;AACvD,kCAAkC,cAAc,EAAE;AAClD,kCAAkC,cAAc,EAAE","sourcesContent":["/* ══════════════════════════════════════════════════════════\n   EmployeeEnrollmentPage\n   ══════════════════════════════════════════════════════════ */\n\n.eep-root {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background: #f5f7fa;\n}\n\n/* ── Header ──────────────────────────────────────────────── */\n.eep-header {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 20px;\n  background: #fff;\n  border-bottom: 1px solid #eaecf0;\n  flex-shrink: 0;\n}\n\n.eep-back-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  border: none;\n  background: #f0f2f5;\n  color: #374151;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.15s;\n}\n.eep-back-btn:hover { background: #e5e7eb; }\n\n.eep-header-text {\n  flex: 1;\n  min-width: 0;\n}\n.eep-header-text h1 {\n  font-size: 16px;\n  font-weight: 700;\n  color: #1a2236;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.eep-header-text p {\n  font-size: 12px;\n  color: #6b7280;\n  margin: 2px 0 0;\n}\n\n.eep-count-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 22px;\n  height: 20px;\n  padding: 0 7px;\n  border-radius: 10px;\n  background: #1e5fbc;\n  color: #fff;\n  font-size: 11px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.eep-refresh-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  color: #6b7280;\n  cursor: pointer;\n  transition: background 0.15s, color 0.15s;\n  flex-shrink: 0;\n}\n.eep-refresh-btn:hover:not(:disabled) { background: #f0f2f5; color: #1e5fbc; }\n.eep-refresh-btn:disabled { opacity: 0.4; cursor: not-allowed; }\n\n/* ── Search + Filter bar ─────────────────────────────────── */\n.eep-search-bar {\n  display: flex;\n  gap: 10px;\n  padding: 14px 20px;\n  background: #fff;\n  border-bottom: 1px solid #eaecf0;\n  flex-shrink: 0;\n}\n\n.eep-search-input-wrap {\n  position: relative;\n  flex: 1;\n  display: flex;\n  align-items: center;\n}\n.eep-search-input-wrap > svg:first-child {\n  position: absolute;\n  left: 11px;\n  color: #9ca3af;\n  pointer-events: none;\n}\n\n.eep-search-input {\n  width: 100%;\n  height: 40px;\n  padding: 0 36px 0 34px;\n  border: 1px solid #d1d5db;\n  border-radius: 10px;\n  font-size: 14px;\n  color: #1a2236;\n  background: #f9fafb;\n  outline: none;\n  transition: border-color 0.15s;\n  box-sizing: border-box;\n}\n.eep-search-input:focus { border-color: #1e5fbc; background: #fff; }\n\n.eep-search-clear {\n  position: absolute;\n  right: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: none;\n  background: #e5e7eb;\n  color: #6b7280;\n  cursor: pointer;\n  padding: 0;\n}\n.eep-search-clear:hover { background: #d1d5db; }\n\n.eep-filter-btn {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  height: 40px;\n  padding: 0 14px;\n  border-radius: 10px;\n  border: 1px solid #d1d5db;\n  background: #fff;\n  color: #374151;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.15s, border-color 0.15s;\n  position: relative;\n}\n.eep-filter-btn:hover { background: #f0f2f5; border-color: #9ca3af; }\n\n.eep-filter-badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 18px;\n  height: 18px;\n  padding: 0 5px;\n  border-radius: 9px;\n  background: #1e5fbc;\n  color: #fff;\n  font-size: 10px;\n  font-weight: 700;\n}\n\n/* ── Employee list ───────────────────────────────────────── */\n.eep-list-wrap {\n  flex: 1;\n  overflow-y: auto;\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.eep-list-center {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 60px 20px;\n  color: #9ca3af;\n  font-size: 14px;\n  text-align: center;\n}\n\n.eep-empty-icon {\n  width: 56px;\n  height: 56px;\n  border-radius: 50%;\n  background: #f0f2f5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #d1d5db;\n}\n.eep-empty-title { font-size: 15px; font-weight: 700; color: #374151; margin: 0; }\n.eep-empty-sub   { font-size: 13px; color: #9ca3af; margin: 0; }\n\n.eep-emp-card {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 14px 16px;\n  border-radius: 12px;\n  border: 1.5px solid #eaecf0;\n  background: #fff;\n  cursor: pointer;\n  text-align: left;\n  transition: border-color 0.15s, box-shadow 0.15s, background 0.15s;\n  box-shadow: 0 1px 3px rgba(0,0,0,0.04);\n}\n.eep-emp-card:hover {\n  border-color: #1e5fbc;\n  box-shadow: 0 2px 8px rgba(30, 95, 188, 0.1);\n  background: #fafcff;\n}\n\n.eep-emp-card-avatar {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: #eff6ff;\n  color: #1e5fbc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.eep-emp-card-info {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.eep-emp-card-name {\n  font-size: 14px;\n  font-weight: 700;\n  color: #1a2236;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.eep-emp-card-id {\n  font-size: 12px;\n  color: #6b7280;\n  font-weight: 500;\n}\n.eep-emp-card-date {\n  font-size: 11px;\n  color: #9ca3af;\n}\n\n.eep-load-more {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  padding: 16px;\n  font-size: 13px;\n  color: #6b7280;\n}\n.eep-list-end {\n  text-align: center;\n  font-size: 12px;\n  color: #d1d5db;\n  padding: 12px 0 4px;\n  margin: 0;\n}\n\n/* ── Filter sidebar ─────────────────────────────────────── */\n.eep-filter-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(10, 14, 30, 0.5);\n  z-index: 900;\n  backdrop-filter: blur(2px);\n}\n\n.eep-filter-sidebar {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: min(360px, 100vw);\n  background: #fff;\n  z-index: 901;\n  display: flex;\n  flex-direction: column;\n  box-shadow: -8px 0 32px rgba(0,0,0,0.18);\n  animation: eep-slide-in 0.22s cubic-bezier(0.16, 1, 0.3, 1);\n}\n@keyframes eep-slide-in {\n  from { transform: translateX(100%); }\n  to   { transform: translateX(0); }\n}\n\n/* Sidebar header — gradient matching the palette */\n.eep-filter-header {\n  background: linear-gradient(135deg, #0d1b3e 0%, #1e4ba0 100%);\n  padding: 20px;\n  flex-shrink: 0;\n}\n.eep-filter-header-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.eep-filter-title { font-size: 16px; font-weight: 800; color: #fff; }\n\n.eep-filter-close-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(255,255,255,0.15);\n  color: #fff;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.eep-filter-close-btn:hover { background: rgba(255,255,255,0.28); }\n\n.eep-filter-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 40px;\n  color: #6b7280;\n  font-size: 14px;\n}\n\n/* Body */\n.eep-filter-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  background: #f8fafc;\n}\n\n/* Individual field */\n.eep-filter-field {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n.eep-filter-field-label {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n  color: #64748b;\n}\n\n/* Custom select */\n.eep-filter-select-wrap {\n  position: relative;\n}\n.eep-filter-select {\n  width: 100%;\n  height: 44px;\n  padding: 0 36px 0 14px;\n  border: 1.5px solid #e2e8f0;\n  border-radius: 10px;\n  font-size: 14px;\n  color: #1a2236;\n  background: #fff;\n  outline: none;\n  appearance: none;\n  -webkit-appearance: none;\n  cursor: pointer;\n  box-sizing: border-box;\n  transition: border-color 0.15s;\n}\n.eep-filter-select:focus { border-color: #1e5fbc; }\n.eep-filter-select-arrow {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #9ca3af;\n  font-size: 12px;\n  pointer-events: none;\n}\n\n/* Footer */\n.eep-filter-footer {\n  display: flex;\n  gap: 10px;\n  padding: 16px 20px;\n  border-top: 1px solid #eaecf0;\n  flex-shrink: 0;\n  background: #fff;\n}\n.eep-filter-clear-btn {\n  flex: 1;\n  height: 44px;\n  border-radius: 10px;\n  border: 1.5px solid #e2e8f0;\n  background: #fff;\n  color: #374151;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.12s;\n}\n.eep-filter-clear-btn:hover { background: #f0f4f8; }\n.eep-filter-apply-btn {\n  flex: 2;\n  height: 44px;\n  border-radius: 10px;\n  border: none;\n  background: linear-gradient(135deg, #0d1b3e, #1e5fbc);\n  color: #fff;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: opacity 0.15s;\n}\n.eep-filter-apply-btn:hover { opacity: 0.9; }\n\n/* ── Registration body ──────────────────────────────────── */\n.eep-reg-body {\n  flex: 1;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  padding: 28px 20px;\n}\n\n.eep-reg-card {\n  width: 100%;\n  max-width: 500px;\n  background: #fff;\n  border-radius: 16px;\n  box-shadow: 0 4px 24px rgba(0,0,0,0.07);\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n/* ── Employee banner (register view) ────────────────────── */\n.eep-emp-banner {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n}\n.eep-emp-info { display: flex; flex-direction: column; gap: 2px; }\n.eep-emp-name { font-size: 15px; font-weight: 700; color: #1a2236; }\n.eep-emp-id   { font-size: 12px; color: #6b7280; }\n\n/* ── Input step ─────────────────────────────────────────── */\n.eep-step-input {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  align-items: stretch;\n}\n.eep-field-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n}\n.eep-field-input {\n  width: 100%;\n  height: 44px;\n  padding: 0 14px;\n  border: 1.5px solid #d1d5db;\n  border-radius: 10px;\n  font-size: 14px;\n  color: #1a2236;\n  outline: none;\n  box-sizing: border-box;\n  transition: border-color 0.15s;\n}\n.eep-field-input:focus { border-color: #1e5fbc; }\n.eep-step-error {\n  padding: 10px 14px;\n  border-radius: 8px;\n  background: #fff1f2;\n  border: 1px solid #fecdd3;\n  color: #be123c;\n  font-size: 13px;\n}\n\n/* ── Camera step ────────────────────────────────────────── */\n.eep-step-camera {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  align-items: center;\n}\n\n.eep-video-wrap {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 4 / 3;\n  border-radius: 12px;\n  overflow: hidden;\n  background: #111827;\n}\n\n.eep-video {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n.eep-video.ready { opacity: 1; }\n\n.eep-video-loading {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  color: #94a3b8;\n  font-size: 14px;\n}\n\n.eep-camera-error {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  color: #94a3b8;\n  padding: 20px;\n  text-align: center;\n  font-size: 14px;\n}\n\n.eep-face-guide {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  pointer-events: none;\n}\n.eep-face-guide::after {\n  content: \"\";\n  width: 52%;\n  aspect-ratio: 3 / 4;\n  border: 2.5px solid rgba(255,255,255,0.65);\n  border-radius: 50%;\n  box-shadow: 0 0 0 9999px rgba(0,0,0,0.32);\n}\n\n.eep-cam-flip-btn {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  border: none;\n  background: rgba(0,0,0,0.45);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: background 0.15s;\n  z-index: 2;\n}\n.eep-cam-flip-btn:hover { background: rgba(0,0,0,0.65); }\n\n.eep-retry-btn {\n  padding: 8px 20px;\n  border-radius: 8px;\n  border: 1px solid #6b7280;\n  background: transparent;\n  color: #9ca3af;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.eep-capture-status {\n  width: 100%;\n  padding: 10px 14px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  text-align: center;\n}\n.eep-capture-status.ok   { background: #f0fdf4; color: #15803d; border: 1px solid #bbf7d0; }\n.eep-capture-status.fail { background: #fff1f2; color: #be123c; border: 1px solid #fecdd3; }\n\n.eep-capture-hint {\n  font-size: 12px;\n  color: #9ca3af;\n  text-align: center;\n}\n\n.eep-text-btn {\n  background: none;\n  border: none;\n  color: #6b7280;\n  font-size: 13px;\n  cursor: pointer;\n  padding: 4px 0;\n  text-decoration: underline;\n  text-underline-offset: 2px;\n}\n.eep-text-btn:hover { color: #374151; }\n\n/* ── Preview step ───────────────────────────────────────── */\n.eep-step-preview {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  align-items: center;\n}\n.eep-preview-label {\n  font-size: 13px;\n  font-weight: 700;\n  color: #374151;\n  margin: 0;\n  align-self: flex-start;\n}\n.eep-preview-img-wrap {\n  width: 100%;\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1.5px solid #eaecf0;\n  background: #111827;\n  aspect-ratio: 4 / 3;\n}\n.eep-preview-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n.eep-preview-actions {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n}\n/* Fix: override width:100% so Register shares the row evenly with Retake */\n.eep-preview-actions .eep-action-btn,\n.eep-success-actions .eep-action-btn {\n  width: auto;\n  flex: 2;\n}\n\n/* ── Enrolling step ─────────────────────────────────────── */\n.eep-step-enrolling {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding: 20px 0;\n}\n.eep-enrolling-spinner {\n  width: 52px;\n  height: 52px;\n  border: 4px solid #e2e8f0;\n  border-top-color: #1e5fbc;\n  border-radius: 50%;\n  animation: eep-spin 0.8s linear infinite;\n}\n.eep-enrolling-msg {\n  font-size: 15px;\n  font-weight: 600;\n  color: #374151;\n  margin: 0;\n}\n\n/* ── Success step ───────────────────────────────────────── */\n.eep-step-success {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n  padding: 10px 0;\n  text-align: center;\n}\n.eep-success-icon {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background: #f0fdf4;\n  border: 2px solid #bbf7d0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: eep-pop-in 0.3s cubic-bezier(0.16,1,0.3,1);\n}\n@keyframes eep-pop-in {\n  from { transform: scale(0.7); opacity: 0; }\n  to   { transform: scale(1);   opacity: 1; }\n}\n.eep-success-title {\n  font-size: 20px;\n  font-weight: 800;\n  color: #1a2236;\n  margin: 0;\n}\n.eep-success-sub {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0;\n  line-height: 1.5;\n}\n.eep-success-api-msg {\n  font-size: 13px;\n  font-weight: 600;\n  color: #16a34a;\n  margin: 0;\n  padding: 8px 16px;\n  background: #f0fdf4;\n  border-radius: 8px;\n  border: 1px solid #bbf7d0;\n  width: 100%;\n}\n.eep-success-actions {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n  margin-top: 4px;\n}\n\n/* ── Shared buttons ─────────────────────────────────────── */\n.eep-action-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  height: 46px;\n  border-radius: 10px;\n  border: none;\n  background: linear-gradient(135deg, #0d1b3e, #1e5fbc);\n  color: #fff;\n  font-size: 14px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: opacity 0.15s, transform 0.1s;\n  flex-shrink: 0;\n}\n.eep-action-btn:hover:not(:disabled) { opacity: 0.9; transform: translateY(-1px); }\n.eep-action-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n\n.eep-secondary-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  height: 46px;\n  border-radius: 10px;\n  border: 1.5px solid #d1d5db;\n  background: #fff;\n  color: #374151;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.eep-secondary-btn:hover { background: #f0f2f5; }\n\n/* ── Already-enrolled modal ─────────────────────────────── */\n.eep-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.5);\n  z-index: 1000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n}\n.eep-modal {\n  background: #fff;\n  border-radius: 16px;\n  padding: 28px 24px 22px;\n  max-width: 400px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  text-align: center;\n  box-shadow: 0 20px 60px rgba(0,0,0,0.2);\n  animation: eep-pop-in 0.25s cubic-bezier(0.16,1,0.3,1);\n}\n.eep-modal-icon {\n  font-size: 36px;\n  line-height: 1;\n}\n.eep-modal-title {\n  font-size: 18px;\n  font-weight: 800;\n  color: #1a2236;\n  margin: 0;\n}\n.eep-modal-msg {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0;\n  line-height: 1.6;\n}\n.eep-modal-actions {\n  display: flex;\n  gap: 10px;\n  width: 100%;\n  margin-top: 6px;\n}\n\n/* ── Spinners ────────────────────────────────────────────── */\n.eep-spinner {\n  width: 26px;\n  height: 26px;\n  border: 3px solid #e2e8f0;\n  border-top-color: #1e5fbc;\n  border-radius: 50%;\n  animation: eep-spin 0.7s linear infinite;\n  flex-shrink: 0;\n}\n.eep-spinner-sm {\n  width: 15px;\n  height: 15px;\n  border: 2px solid rgba(255,255,255,0.35);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: eep-spin 0.7s linear infinite;\n  flex-shrink: 0;\n}\n@keyframes eep-spin { to { transform: rotate(360deg); } }\n\n/* ══════════════════════════════════════════════════════════\n   Dark mode\n   ══════════════════════════════════════════════════════════ */\n.dark .eep-root                 { background: #121827; }\n.dark .eep-header               { background: #1a2236; border-color: #2e3d52; }\n.dark .eep-header-text h1       { color: #e2e8f0; }\n.dark .eep-header-text p        { color: #94a3b8; }\n.dark .eep-back-btn             { background: #263348; color: #cbd5e1; }\n.dark .eep-back-btn:hover       { background: #2e3d52; }\n.dark .eep-refresh-btn          { background: #1a2236; border-color: #2e3d52; color: #94a3b8; }\n.dark .eep-refresh-btn:hover    { background: #263348; color: #7eb3ff; }\n\n/* Search bar */\n.dark .eep-search-bar           { background: #1a2236; border-color: #2e3d52; }\n.dark .eep-search-input         { background: #0f1724; border-color: #2e3d52; color: #e2e8f0; }\n.dark .eep-search-input:focus   { border-color: #7eb3ff; }\n.dark .eep-search-clear         { background: #263348; color: #94a3b8; }\n.dark .eep-filter-btn           { background: #1a2236; border-color: #2e3d52; color: #cbd5e1; }\n.dark .eep-filter-btn:hover     { background: #263348; }\n\n/* List */\n.dark .eep-list-wrap            { /* transparent */ }\n.dark .eep-emp-card             { background: #1a2236; border-color: #2e3d52; }\n.dark .eep-emp-card:hover       { border-color: #7eb3ff; background: #1e2a42; }\n.dark .eep-emp-card-avatar      { background: #1e3a6e; color: #7eb3ff; }\n.dark .eep-emp-card-name        { color: #e2e8f0; }\n.dark .eep-emp-card-id          { color: #64748b; }\n.dark .eep-emp-card-date        { color: #4b5e76; }\n.dark .eep-empty-title          { color: #94a3b8; }\n\n/* Filter sidebar */\n.dark .eep-filter-backdrop      { background: rgba(0,0,0,0.65); }\n.dark .eep-filter-sidebar       { background: #1a2236; }\n/* header is gradient — stays dark */\n.dark .eep-filter-body          { background: #0f1724; }\n.dark .eep-filter-field-label   { color: #64748b; }\n.dark .eep-filter-select        { background: #1a2236; border-color: #2e3d52; color: #e2e8f0; }\n.dark .eep-filter-select:focus  { border-color: #7eb3ff; }\n.dark .eep-filter-select-arrow  { color: #4b5e76; }\n.dark .eep-filter-footer        { border-color: #2e3d52; background: #1a2236; }\n.dark .eep-filter-clear-btn     { background: #1a2236; border-color: #2e3d52; color: #cbd5e1; }\n.dark .eep-filter-clear-btn:hover { background: #263348; }\n\n/* Registration */\n.dark .eep-reg-card             { background: #1a2236; box-shadow: 0 4px 24px rgba(0,0,0,0.3); }\n.dark .eep-emp-banner           { background: #0f1f3d; border-color: #1e3a6e; }\n.dark .eep-emp-name             { color: #e2e8f0; }\n.dark .eep-emp-id               { color: #94a3b8; }\n.dark .eep-field-label          { color: #94a3b8; }\n.dark .eep-field-input          { background: #0f1724; border-color: #2e3d52; color: #e2e8f0; }\n.dark .eep-field-input:focus    { border-color: #7eb3ff; }\n.dark .eep-step-error           { background: #1f0a10; border-color: #9f1239; color: #fb7185; }\n.dark .eep-capture-status.ok    { background: #052e16; color: #4ade80; border-color: #166534; }\n.dark .eep-capture-status.fail  { background: #1f0a10; color: #fb7185; border-color: #9f1239; }\n.dark .eep-capture-hint         { color: #64748b; }\n.dark .eep-preview-label        { color: #94a3b8; }\n.dark .eep-preview-img-wrap     { border-color: #2e3d52; }\n.dark .eep-enrolling-msg        { color: #94a3b8; }\n.dark .eep-enrolling-spinner    { border-color: #2e3d52; border-top-color: #7eb3ff; }\n.dark .eep-spinner              { border-color: #2e3d52; border-top-color: #7eb3ff; }\n.dark .eep-success-title        { color: #e2e8f0; }\n.dark .eep-success-sub          { color: #94a3b8; }\n.dark .eep-success-api-msg      { background: #052e16; border-color: #166534; color: #4ade80; }\n.dark .eep-success-icon         { background: #052e16; border-color: #166534; }\n.dark .eep-secondary-btn        { background: #1a2236; border-color: #2e3d52; color: #cbd5e1; }\n.dark .eep-secondary-btn:hover  { background: #263348; }\n.dark .eep-text-btn             { color: #64748b; }\n.dark .eep-text-btn:hover       { color: #94a3b8; }\n.dark .eep-modal                { background: #1a2236; }\n.dark .eep-modal-title          { color: #e2e8f0; }\n.dark .eep-modal-msg            { color: #94a3b8; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
